import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { Typography } from 'kangarootime-ui';
import classnames from 'classnames';
import moment from 'moment';
import '../../shared/Table.css';

const CustomToolTip = withStyles(theme => ({
  tooltip: {
    fontSize: '1rem'
  }
}))(Tooltip);

const ShiftInformation = ({ shift, lastShiftInCell }) => {
  const formatTime = date => moment(date).format('h:mm a');
  const { start, end, roomName } = shift;
  const startTime = formatTime(start);
  const endTime = formatTime(end);
  const shiftDurationInMinutes = moment(end).diff(moment(start), 'minutes');
  const shiftDuration = (shiftDurationInMinutes / 60).toFixed(2);
  const label = `${startTime} - ${endTime} (${roomName})`;
  const cellClassNames = classnames({
    'flex-columns': true,
    'shift-time-cell': true,
    'shift-time-cell-today': moment(start).isSame(moment(), 'day')
  });

  return (
    <CustomToolTip title={`Shift Duration: ${shiftDuration} hours`}>
      <div
        className={cellClassNames}
        style={{ borderBottom: !lastShiftInCell && '1px solid #F1F1F3', position: 'relative' }}
      >
        <Typography style={{ fontSize: '0.75rem', whiteSpace: 'nowrap', margin: '4px 0' }}>{label}</Typography>
      </div>
    </CustomToolTip>
  );
};

ShiftInformation.propTypes = {
  shift: PropTypes.shape({
    id: PropTypes.number,
    employeeId: PropTypes.number,
    roomId: PropTypes.number,
    start: PropTypes.oneOf(PropTypes.instanceOf(Date), PropTypes.string),
    end: PropTypes.oneOf(PropTypes.instanceOf(Date), PropTypes.string),
    breakMinutes: PropTypes.oneOf(PropTypes.number, PropTypes.string)
  }),
  lastShiftInCell: PropTypes.bool
};

export default ShiftInformation;
